/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import * as Sebrae from '@sebrae/react-core';

import imageHero from '../../../shared/assets/hero-urbano.png';
import imageUnctad from '../../../shared/assets/logo-unctad.png';
import CommonButton from '../../../shared/components/common-button/common-button';
import { Footer } from '../../../shared/components/footer/footer';
import Header from '../../../shared/components/header/header';
import { useInterviewContext } from '../../../shared/context/interview-context';
import { WithoutInterview } from '../without-interview/without-interview';
import {
  Content,
  ContentButton,
  ContentDescription,
  ContentHero,
  ContentTitle,
  Description,
  GradientContainer,
  Title,
  Wrapper,
} from './candidate-home-new';

export const CandidateHomeNew = () => {
  const { navigateTo, hasQueryString } = Sebrae.useSebraeRouter();
  const { hasRoles, isAuthenticated, login } = Sebrae.useAuth();

  const { interview, moduleColors, loading } = useInterviewContext();


  React.useEffect(() => {
    if (!isAuthenticated) {
      if (hasQueryString('origem')) {
        login();
        return;
      }
      const url = window.location.protocol + '//' + window.location.host;
      navigateTo(`${url}/`);
    } else {
      if (hasQueryString('origem')) {
        const cleanUrl = window.location.pathname;
        const url = window.location.protocol + '//' + window.location.host;
        navigateTo(`${url}/candidato`);
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  }, [isAuthenticated, hasQueryString, login, navigateTo]);

  if (loading) {
    return null;
  }

  if (!interview) {
    return <WithoutInterview />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        justifyContent: 'space-between',
      }}
    >
      <Header />
      <GradientContainer
        primary={moduleColors?.primary}
        secondary={moduleColors?.secondary}
        tertiary={moduleColors?.tertiary}
      >
        <Wrapper>
          <Content>
            <ContentTitle>
              <Title>
                Você é o seu
                <br />
                maior negócio.
              </Title>
              <img src={imageUnctad} alt="imageUnctad" />
            </ContentTitle>
            <ContentDescription>
              <Description>
                Você já deu o primeiro passo. Agora é hora de viver uma
                experiência que vai ampliar sua visão, fortalecer sua liderança
                e preparar você para um novo ciclo de crescimento.
              </Description>
              <Description>
                O Empretec é mais do que um seminário — é um ponto de virada.
                Cada etapa desta jornada foi desenhada para te impulsionar.
                Vamos juntos?
              </Description>
            </ContentDescription>
            <ContentButton>
              <CommonButton
                variant="primary"
                isBold={true}
                backgroundColor="#0000C7"
                onClick={() => {
                  if (hasRoles(['ADMINISTRADOR'])) {
                    navigateTo(`/candidato/sobre-curso/id/${interview?.id}`);
                  } else {
                    navigateTo(`/candidato/sobre-curso`);
                  }
                }}
              >
                Iniciar minha jornada
              </CommonButton>
            </ContentButton>
          </Content>
          <ContentHero>
            <img src={imageHero} alt="hero" />
          </ContentHero>
        </Wrapper>
      </GradientContainer>
      <Footer />
    </div>
  );
};
